(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["isark-posthog"] && !Shopify.designMode) return;
  try {
    document.getElementById('isark-cookie-preferences')?.addEventListener('click', async () => {
    const status = document.getElementById('isark-cookie-preferences-status');
    try {
      if (!window.privacyBanner?.showPreferences) throw new Error('Consent banner unavailable');
      await window.privacyBanner.showPreferences();
      if (status) status.hidden = true;
    } catch {
      if (status) status.hidden = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
